<template>
  <el-dialog title="操作信息"
             :visible="visible"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             @close="cancel"
             width="60%"
             append-to-body>
    <el-form :model="form" ref="form" label-width="120px">
      <el-form-item label="父级操作">
        <el-select v-model="form.parentId">
          <el-option v-for="option in listdata"
                     :key="option.id"
                     :value="option.id"
                     :label="option.alias"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作名称" :rules="rules.requiredItem" prop="alias">
        <!-- <el-input v-model="form.alias" @change="verifyAlias"></el-input> -->
        <el-input v-model="form.alias"></el-input>
      </el-form-item>
      <el-form-item label="字段名称" :rules="rules.requiredItem" prop="name">
        <el-input v-model="form.name" @change="verifyName"></el-input>
        <span>必须是英文字母、数字、下划线</span>
      </el-form-item>
      <!-- <el-form-item label="字段签名" prop="signature">
        <el-input v-model="form.signature"></el-input> -->
        <!-- <span>必须是英文字母、数字、下划线</span> -->
      <!-- </el-form-item> -->
      <!-- <el-form-item label="请求方式" prop="requestType">
        <el-radio-group v-model="form.requestType">
          <el-radio :label="0">get</el-radio>
          <el-radio :label="1">post</el-radio>
          <el-radio :label="2">delete</el-radio>
          <el-radio :label="3">put</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import {Loading} from "element-ui"

export default {
  props: {
    formData: {
      type: Object
    },
    visible: {
      type: Boolean
    },
    listdata: {
      type: Array
    },
    menuId: {
      type: [Number, String]
    }
  },
  data: vm => ({
    rules: {
      requiredItem: [{required: true, message: '必填项'}]
    },
    form: {
      name: '',
      alias: '',
      parentId: null,
      menuId: '',
      signature: '',
      requestType: 0, //请求方式
    }
  }),
  created() {
    if (this.formData) {
      if (this.formData.parentId) {
        this.form.parentId = this.formData.parentId
      }
      this.findById(this.formData.id)
    }

    // let obj = {
    //   alias: "无",
    //   id: 0
    // }
    // this.listdata.push(obj);
  },
  methods: {
    findById(id) {
      if (!id) {
        return
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let url = this.baseUrl3 + "button/findById/" + id
      this.$axios
        .get(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.form = data
            if (data.parentId) {
              this.form.parentId = data.parentId
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        })
        .catch(error => {
          loading.close();
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    verifyAlias(val) {
      this.$axios
        .get(this.baseUrl3 + 'button/verifyAlias/' + val + '/' + this.menuId)
        .then(({data: {data, code, msg}}) => {
          if (data) {
            this.$message.warning('名字重复，请重新填写')
            this.form.alias = ''
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    verifyName(name) {
      if (this.form.parentId == null){
        this.form.parentId = 0
      }
      this.$axios
        .get(this.baseUrl3 + 'button/verifyName/' + name + '/' + this.menuId+ '/' + this.form.parentId)
        .then(({data: {data, code, msg}}) => {
          if (data) {
            this.$message.warning('名字重复，请重新填写')
            this.form.name = ''
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    save() {
      let url = this.baseUrl3 + 'button/add'
      if (this.form.id) {
        url = this.baseUrl3 + 'button/edit'
      }
      if (this.form.parentId == null){
        this.form.parentId = 0
      }
      let model = {
        name: this.form.name,
        id: this.form.id,
        alias: this.form.alias,
        parentId: this.form.parentId,
        appId: this.menuId
      }

      this.$axios.post(url, model)
        .then(({data: {data, msg, code}}) => {
          if (code == 20000) {
            this.$emit('findByAppId')
            this.$emit('operationAddCallback')
            // this.cancel({
            //   id: data,
            //   alias: this.form.alias,
            //   parentId: this.form.parentId
            // })
          } else {
            this.$message.error('操作失败：' + msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancel() {
      this.$emit('operationAddCallback')
    },
  },
}
</script>
<style scoped>
.itemWidth {
  width: 50%;
}
</style>
